import axiosClient from "../axiosClient";
import { ref, inject } from "vue";
import { useRouter } from "vue-router";

export default function useTaxes() {
  const taxes = ref({});
  const tax = ref({});
  const validationErrors = ref({});
  const isLoading = ref(false);

  const router = useRouter();
  const swal = inject("$swal");

  const getTaxes = async (
    page = 1,
    search_id = "",
    search_name_en = "",
    search_name_ar = "",
    search_global = "",
    order_column = "created_at",
    order_direction = "desc",
    per_page = 10
  ) => {
    axiosClient
      .get(
        "/taxes?" +
          "page=" +
          page +
          "&search_id=" +
          search_id +
          "&search_name_en=" +
          search_name_en +
          "&search_name_ar=" +
          search_name_ar +
          "&search_global=" +
          search_global +
          "&order_column=" +
          order_column +
          "&order_direction=" +
          order_direction +
          "&per_page=" +
          per_page
      )
      .then((response) => {
        taxes.value = response.data;
      })
      .catch((error) => {
        if (error.response?.data) {
          validationErrors.value = error.response.data.errors;

          swal({
            icon: "error",
            title: "Server error, please try again.",
          });
        }
      });
  };

  const getTax = async (id) => {
    axiosClient.get("/taxes/" + id).then((response) => {
      tax.value = response.data.data;
    });
  };

  const storeTax = async (tax) => {
    if (isLoading.value) return;

    isLoading.value = true;
    validationErrors.value = {};

    let serializedTax = new FormData();
    for (let item in tax) {
      if (tax.hasOwnProperty(item)) {
        serializedTax.append(item, tax[item]);
      }
    }

    axiosClient
      .post("/taxes", serializedTax)
      .then((response) => {
        router.push({ name: "taxes.index" });
        swal({
          icon: "success",
          title: "Tax saved successfully",
        });
      })
      .catch((error) => {
        if (error.response.data.errors) {
          validationErrors.value = error.response.data.errors;
        }
      })
      .finally(() => (isLoading.value = false));
  };

  const updateTax = async (tax) => {
    if (isLoading.value) return;

    isLoading.value = true;
    validationErrors.value = {};

    axiosClient
      .put("/taxes/" + tax.id, tax)
      .then((response) => {
        router.push({ name: "taxes.index" });
        swal({
          icon: "success",
          title: "Tax saved successfully",
        });
      })
      .catch((error) => {
        if (error.response.data.errors) {
          validationErrors.value = error.response.data.errors;
        }
      })
      .finally(() => (isLoading.value = false));
  };

  const deleteTax = async (id) => {
    swal({
      title: "Are you sure?",
      text: "You won't be able to revert this action!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      confirmButtonColor: "#ef4444",
      timer: 20000,
      timerProgressBar: true,
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed) {
        axiosClient
          .delete("/taxes/" + id)
          .then((response) => {
            getTaxes();
            router.push({ name: "taxes.index" });
            swal({
              icon: "success",
              title: "Tax deleted successfully",
            });
          })
          .catch((error) => {
            swal({
              icon: "error",
              title: "Something went wrong",
            });
          });
      }
    });
  };

  return {
    taxes,
    tax,
    getTaxes,
    getTax,
    storeTax,
    validationErrors,
    isLoading,
    updateTax,
    deleteTax,
  };
}
